module.exports = __webpack_public_path__ + "img/pitching6.6e7a1d61.png";